"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateQueueWithAssignmentsData = exports.CreateQueueData = exports.UpdateAnnotationScoreData = exports.CreateAnnotationScoreData = void 0;
const zod_1 = __importDefault(require("zod"));
const zod_2 = require("../../utils/zod");
const scores_1 = require("../../domain/scores");
const ScoreTargetTrace = zod_1.default.object({
    type: zod_1.default.literal("trace"),
    traceId: zod_1.default.string(),
    observationId: zod_1.default.string().optional(),
});
const ScoreTargetSession = zod_1.default.object({
    type: zod_1.default.literal("session"),
    sessionId: zod_1.default.string(),
});
// Your existing ScoreTarget remains the same, but can now use these components
const ScoreTarget = zod_1.default.discriminatedUnion("type", [
    ScoreTargetTrace,
    ScoreTargetSession,
]);
const CreateAnnotationScoreBase = zod_1.default.object({
    id: zod_1.default.string().optional(),
    name: zod_2.StringNoHTMLNonEmpty,
    value: zod_1.default.number(),
    projectId: zod_1.default.string(),
    environment: zod_1.default.string().default("default"),
    scoreTarget: ScoreTarget,
    configId: zod_1.default.string(),
    comment: zod_2.StringNoHTML.nullish(),
    queueId: zod_1.default.string().nullish(),
    timestamp: zod_1.default.coerce.date().optional(), // Required for ClickHouse deduplication - coerce handles string/number inputs
});
const UpdateAnnotationScoreBase = CreateAnnotationScoreBase.extend({
    id: zod_1.default.string(),
});
const AnnotationBooleanData = zod_1.default.object({
    stringValue: zod_1.default.enum(["True", "False"]),
    dataType: zod_1.default.literal("BOOLEAN"),
});
// The router persists `value` and `stringValue` verbatim, and the two feed
// different filter paths (scores_avg vs score_booleans) — derive `value` from
// the label so a crafted request cannot store an inconsistent pair like
// { stringValue: "True", value: 0 }.
const deriveBooleanValue = (data) => data.dataType === "BOOLEAN"
    ? { ...data, value: data.stringValue === "True" ? 1 : 0 }
    : data;
/**
 * CreateAnnotationScoreData is only used for annotation scores created via the UI.
 * For langfuse score types please refer to `web/src/features/public-api/types/scores.ts`
 */
exports.CreateAnnotationScoreData = CreateAnnotationScoreBase.and(zod_1.default.discriminatedUnion("dataType", [
    scores_1.NumericData,
    scores_1.CategoricalData,
    AnnotationBooleanData,
    scores_1.TextData,
])).transform(deriveBooleanValue);
/**
 * UpdateAnnotationScoreData is only used for annotation scores updated via the UI
 * For langfuse score types please refer to `web/src/features/public-api/types/scores.ts`
 */
exports.UpdateAnnotationScoreData = UpdateAnnotationScoreBase.and(zod_1.default.discriminatedUnion("dataType", [
    scores_1.NumericData,
    scores_1.CategoricalData,
    AnnotationBooleanData,
    scores_1.TextData,
])).transform(deriveBooleanValue);
// annotation queues
exports.CreateQueueData = zod_1.default.object({
    name: zod_2.StringNoHTMLNonEmpty.max(35),
    description: zod_2.StringNoHTML.max(1000).optional(),
    scoreConfigIds: zod_1.default.array(zod_1.default.string()).min(1, {
        message: "At least 1 score config must be selected",
    }),
});
exports.CreateQueueWithAssignmentsData = exports.CreateQueueData.extend({
    newAssignmentUserIds: zod_1.default.array(zod_1.default.string()),
});
